import { useState } from "react";
import {
  searchBibleVerse,
  BibleSearchResult,
  DEFAULT_TRANSLATION,
} from "@/lib/bible-api";

interface UseBibleSearchResult {
  result: BibleSearchResult | null;
  isLoading: boolean;
  error: string | null;
  searchReference: (
    reference: string,
    translation?: string,
    bibleId?: number,
  ) => Promise<BibleSearchResult | null>;
  clear: () => void;
}

export function useBibleSearch(): UseBibleSearchResult {
  const [result, setResult] = useState<BibleSearchResult | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const searchReference = async (
    reference: string,
    translation: string = DEFAULT_TRANSLATION,
    bibleId?: number,
  ) => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await searchBibleVerse(reference, translation, bibleId);
      setResult(data);
      return data;
    } catch (err) {
      console.error("Error looking up Bible passage:", err);
      const message =
        err instanceof Error
          ? err.message
          : "Could not find that reference. Check the format and try again.";
      setError(message);
      setResult(null);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  const clear = () => {
    setResult(null);
    setError(null);
  };

  return {
    result,
    isLoading,
    error,
    searchReference,
    clear,
  };
}
